export const API_URL = process.env.REACT_APP_PYTHON_URL;
export const LAYER1_API_URL = process.env.REACT_APP_LAYER1_URL;
export const LAYER2_API_URL = process.env.REACT_APP_LAYER2_URL;
export const JOBS_PORTAL_URL = process.env.REACT_APP_JOB_PORTAL_URL;
export const TWILIO_URL = process.env.REACT_APP_TWILIO_URL;
